export default "__VITE_ASSET__BnLwdOpd__"